module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("8o3C0"))).then(() => module.bundle.root('ewmtE'));